import api from "../../Http/global-vars";
import { FETCH_CONTACTS_MESSAGES } from "../types";
import axios from "axios";

export const fetchMessagesContact = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "contact/";
    await axios
      .get(url, config)
      .then(async (res) => {
        // const data = await res.json();
        // console.log("data projects", res);
        dispatch({
          type: FETCH_CONTACTS_MESSAGES,
          payload: res?.data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
